import { createStore } from 'vuex'
import lang from './modules/lang'
import user from './modules/user'
import menu from './modules/menu'
import permission from './modules/permission'

const store = createStore({
  modules: {
    lang,
    user,
    permission,
    menu
  }
})
export default  store